import api from "./api"
import axios from "axios"
import {videoUrl} from "@/config"


axios.headers = 'application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export function post(url, params) {
    let dataStr = ''
    Object.keys(params).map(key => {
        dataStr += dataStr ? `&${key}=${params[key]}` : `${key}=${params[key]}`
    })
    return new Promise((resolve, reject) => {
        axios.post(videoUrl + url,
            dataStr,
            {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
            .then(response => {
                resolve(response);
            }, err => {
                console.info("请求地址出错", url, err);
                reject(err);
            }).catch(error => {
            console.info("请求地址出错", url, error);
            reject(error);
        });
    });
}

export default {api,}